import { useCallback, useState } from "react";

/**
 * Hook that returns state and handlers for the upgrade limit modal (402).
 * Use when mutation fails with 402 - e.g. createPortfolioFolder, createPortfolioStock.
 * Render UpgradeLimitModal with the returned props.
 */
export const useShowUpgradeModal = () => {
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);

  const showUpgradeModal = useCallback(() => {
    setIsUpgradeModalOpen(true);
  }, []);

  const closeUpgradeModal = useCallback(() => {
    setIsUpgradeModalOpen(false);
  }, []);

  return {
    showUpgradeModal,
    isUpgradeModalOpen,
    closeUpgradeModal,
  };
};
